/**
 * Typed refusal codes for a public signup-sheet registration (plan
 * 2026-09-18-0147, U5 — KTD5, R8).
 *
 * Every one of these is a 409: the request is well-formed and the sheet is
 * real, but the spot cannot be given. The client maps the CODE to its own copy
 * rather than rendering the server's message (R8), so a wording change is a web
 * deploy, not a backend one — and the mobile and web surfaces cannot drift into
 * two different explanations of the same refusal.
 *
 * `capacity_exhausted` is listed here although its gate predates this plan: the
 * public form needs one exhaustive list to switch on, and leaving the oldest
 * refusal out of it would make that switch silently non-exhaustive.
 */

import { z } from 'zod'

export const SIGNUP_ORDER_ERROR_CODES = [
  /** The slot is gone or cancelled — "this date is no longer available" (AE17, R19). */
  'slot_unavailable',
  /** The slot's cutoff has passed — "sign-up for this date closed at …" (R7, AE2). */
  'slot_closed',
  /** This registrant already holds a spot for this participant on this slot (R12, AE1). */
  'duplicate_participant',
  /** This registrant is at the sheet's per-registrant cap across the horizon (R9, AE10). */
  'registrant_cap_exceeded',
  /** The slot has no spots left (R7, AE3). */
  'capacity_exhausted'
] as const

export const SignupOrderErrorCodeSchema = z.enum(SIGNUP_ORDER_ERROR_CODES)
export type SignupOrderErrorCode = z.infer<typeof SignupOrderErrorCodeSchema>
